import { render, staticRenderFns } from "./SuspectedAlertCount.vue?vue&type=template&id=3de8a6ea"
import script from "./SuspectedAlertCount.vue?vue&type=script&lang=js"
export * from "./SuspectedAlertCount.vue?vue&type=script&lang=js"
import style0 from "./SuspectedAlertCount.vue?vue&type=style&index=0&id=3de8a6ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports